
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PrimaryLiverCancer',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/PrimaryLiverCancer.vue